import { render, staticRenderFns } from "./tableTree.vue?vue&type=template&id=28a2af4e&scoped=true"
import script from "./tableTree.vue?vue&type=script&lang=js"
export * from "./tableTree.vue?vue&type=script&lang=js"
import style0 from "./tableTree.vue?vue&type=style&index=0&id=28a2af4e&prod&lang=scss&scoped=true"
import style1 from "./tableTree.vue?vue&type=style&index=1&id=28a2af4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2af4e",
  null
  
)

export default component.exports